module.exports = __webpack_public_path__ + "img/IMG-20200718-WA0008.ee230221.jpg";